import React from "react";
import { Modal, Upload, Image, ConfigProvider, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ProxyFileUpload } from '../../../services/data/DataService';

import zh_CN from 'antd/lib/locale-provider/zh_CN';

class Photo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            fileList: props.logo ? [{ url: props.logo }] : [],
            setVedioProgress: [null],
            previewVisible: false,
            previewImage: '',
            previewTitle: ''
        }
    }

    //图片预览
    handlePreview = (e) => {
        if (e.url) {
            this.setState({
                previewImage: e.url
            })


        } else if (e.response) {
            this.setState({
                previewImage: e.response.data.url
            })
        }
        this.setState({
            previewVisible: true,
            previewTitle: "图片预览"
        })
    }

    handleChange = async (file) => {
        try {
            const res = await ProxyFileUpload(file);
            if (res.code === 0 || res.code === '0') {
                const url = res.data?.url || res.data;
                if (url) {
                    this.props.onChange(url)
                    this.setState({
                        fileList: [{ url: url, uid: file.uid }]
                    })
                }
            } else {
                message.error(res.message || '上传失败，请重试！')
            }
        } catch (err) {
            message.error('上传失败，请重试！')
        }
    }



    handleCancel = () => {
        this.setState({
            previewVisible: false
        })
    }



    removeChange = (file) => {

        console.log(this.state.fileList)
        let _fileList = this.state.fileList.filter((v) => v.uid !== file.uid)

        this.setState({
            fileList: _fileList
        })
        this.props.onChange()
    }

    render() {
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>点击上传图片</div>
            </div>
        );

        const { fileList, previewVisible, previewImage, previewTitle, visible } = this.state

        return (
            <div className="photoCom" >
                {
                    < div >
                        <Upload
                            customRequest={() => { }}
                            accept="image/*"
                            // headers={utils.getHeaders(extraHeader)}
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={this.handlePreview}
                            beforeUpload={this.handleChange}
                            onRemove={this.removeChange}

                        >
                            {fileList.length >= 1 ? null : uploadButton}
                        </Upload>
                        <Modal
                            visible={previewVisible}
                            title={previewTitle}
                            footer={null}
                            // zIndex={99999}
                            onCancel={this.handleCancel}
                        >
                            <ConfigProvider locale={zh_CN}>

                                <Image
                                    width={'100%'}
                                    src={previewImage}
                                    preview={{ visible: false }}
                                    onClick={() => this.setState({
                                        visible: true
                                    })}
                                />

                                <div style={{ display: 'none' }}>
                                    <Image.PreviewGroup preview={{
                                        visible, onVisibleChange: vis => this.setState({
                                            visible: vis
                                        })
                                    }}>
                                        <Image src={previewImage} />
                                        {
                                            fileList && fileList.length > 0 && fileList.map((file) => (
                                                previewImage != file.url && <Image src={file.url} />
                                            ))
                                        }
                                    </Image.PreviewGroup>
                                </div>
                            </ConfigProvider>
                        </Modal>
                    </div >
                }
            </div >
        )
    }
}
export default Photo
